(() => {
 const scan = () => document.querySelectorAll('[data-ploy-page="giving-back"]').forEach(root => {
   if (root.dataset.bcrfReady) return;
   root.dataset.bcrfReady = 'true';
   const config = root.closest('[id^="shopify-section-"]')?.querySelector('[data-bcrf-link-label]');
   let label = 'Learn more about BCRF';
   try { label = JSON.parse(config.textContent) || label; } catch {}
   const apply = () => root.querySelectorAll('a[href^="https://www.bcrf.org"]').forEach(link => {
     if (link.querySelector('.koppa-bcrf-link')) return;
     const span = document.createElement('span'); span.className = 'koppa-bcrf-link'; span.textContent = label;
     const arrow = document.createElement('span'); arrow.setAttribute('aria-hidden','true'); arrow.textContent = '↗'; span.append(arrow); link.append(span);
   });
   apply(); new MutationObserver(apply).observe(root,{childList:true,subtree:true});
 });
 scan(); document.addEventListener('shopify:section:load',scan);
})();
